import React, { useState } from 'react';
import { Save } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

/** Inline editor (publish_at + status + save) for a single blog post row. */
const BlogPostScheduler = ({ post, formatDateInput, onSave }) => {
  const [publishAt, setPublishAt] = useState(formatDateInput(post.publish_at));
  const [status, setStatus] = useState(post.status);
  const [isSaving, setIsSaving] = useState(false);

  const dirty =
    publishAt !== formatDateInput(post.publish_at) || status !== post.status;

  const handleSave = async () => {
    setIsSaving(true);
    try {
      await onSave({ publish_at: new Date(publishAt).toISOString(), status });
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="flex flex-wrap items-end gap-3 pt-2 border-t border-gray-100">
      <div className="flex-1 min-w-[200px]">
        <Label htmlFor={`pub-${post.slug}`} className="text-xs">Publish at</Label>
        <Input
          id={`pub-${post.slug}`}
          type="datetime-local"
          value={publishAt}
          onChange={(e) => setPublishAt(e.target.value)}
          className="mt-1"
        />
      </div>
      <div>
        <Label htmlFor={`status-${post.slug}`} className="text-xs">Status</Label>
        <select
          id={`status-${post.slug}`}
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          className="mt-1 h-10 rounded-md border border-input bg-background px-3 text-sm"
        >
          <option value="scheduled">Scheduled</option>
          <option value="draft">Draft</option>
        </select>
      </div>
      <Button
        onClick={handleSave}
        disabled={!dirty || isSaving}
        className="bg-coral-500 hover:bg-coral-600 text-white"
        data-testid="admin-blog-save-button"
      >
        <Save className="w-4 h-4 mr-2" />
        {isSaving ? 'Saving…' : 'Save'}
      </Button>
    </div>
  );
};

export default BlogPostScheduler;
